module.exports = __webpack_public_path__ + "img/pic02.17f3a6ed.png";